
import { Typography, useTheme } from "@mui/material";
import {
  type MRT_ColumnDef
} from "material-react-table";
import { useMemo, useState } from "react";
import { AdminGlobalTable } from "../../../tables/AdminGlobalTable";
import { ActionCell } from "./TableCell";
import PendingUserActionModal from "./Modal/PendingUserActionModal";

export type TOrgUser = {
  name: string;
  email: string;
  invitationCode: string;
  created: string;
};
const userTableCol = (setOpenPendingUserActionModal,setTitle,setSingleUserData) => [
    {
    accessorKey: "name",
    header: "Name",
    size: 120,
    Cell: (cell) => {
      return <Typography fontSize="15px">{cell.row.original.name}</Typography>;
    }
  },
  {
    accessorKey: "email",
    header: "Email",
    size: 120,
    Cell: (cell) => {
      return <Typography fontSize="15px">{cell.row.original.email}</Typography>;
    }
  },
  {
    accessorKey: "invitationCode",
    header: "Invitecode",
    size: 120,
    Cell: (cell) => {
      return <Typography fontSize="15px">{cell.row.original.invitationCode}</Typography>;
    }
  },
  {
    accessorKey: "created",
    header: "Created",
    size: 120,
    Cell: (cell) => {
      return <Typography fontSize="15px">{cell.row.original.created}</Typography>;
    }
  },
  {
    id: "action",
    header: "Action",
    muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'center',
      },
    size: 120,
    Cell: (props) =>  ActionCell({
      ...props,
      setOpenPendingUserActionModal,
      setTitle,
      setSingleUserData
    })
  },
] as MRT_ColumnDef<TOrgUser>[];


const PendingUserListTable = ({pendingUserList}) => {
  const theme = useTheme();
  const [openPendingUserActionModal, setOpenPendingUserActionModal] = useState(false);
  const [singleInviteUserData,setSingleUserData] = useState({});
  const [title, setTitle] = useState("")

  const columns = useMemo<MRT_ColumnDef<TOrgUser>[]>(
      () => userTableCol(setOpenPendingUserActionModal,setTitle,setSingleUserData),
      []
    );

  return (
    <>
      <PendingUserActionModal
        singleInviteUserData={singleInviteUserData}
        open={openPendingUserActionModal}
        handleClose={()=>setOpenPendingUserActionModal(false)}
        title={title}
      />

      <AdminGlobalTable
        columns={columns}
        data={pendingUserList}
        config={{
          enablePagination: true,
          enableRowVirtualization: false,
          enableColumnVirtualization: false,
          enableSelectAll: true,
          enableStickyHeader: true,
          // enableRowSelection: true,
          // muiSelectCheckboxProps: { 
          //   color: "secondary",
          //   sx:{ 
          //     '& input[type="checkbox"]': {
          //     height: '44px !important',
          //   },}
          //  },
          muiTableContainerProps: {
            sx: {
              maxHeight: "calc(100vh - 585px)",
              minHeight: "calc(100vh - 585px)",
            },
          },
          muiTableBodyRowProps: () => ({
            hover: false,
            sx: {
              backgroundColor: "transparent",
              ":hover": { backgroundColor: theme.custom.hoverOptionColor },
            },
          }),
          renderTopToolbarCustomActions: ({ table }) => (
            <Typography sx={{ fontSize: "16px", color: "#626262" }}>
             Invite User List
           </Typography>
          ),
        }}
      />
    </>
  );
};

export default PendingUserListTable;
